module.exports = __webpack_public_path__ + "static/media/images.5c6a8d1c.zip";